import _, { set } from 'lodash';
import PropTypes from 'prop-types';
import { useState } from 'react';
import styled from 'styled-components';
import '../../helpers/HelperFunctions.js';

import { Button, notification } from 'antd';
import { AppStore, ShopStore, WorkOrderStore } from 'stores';
import { PitstopTableCacheStore } from 'stores/CacheStore';

import { BookOutlined } from '@ant-design/icons';
import CreateWorkOrderModal from 'containers/WorkOrder/modals/CreateWorkOrderModal';

const Container = styled.div`
  padding-right: 2vw;
`;

const CREATE_WORK_ORDER_MODAL_ID = 'CREATE_WORK_ORDER_MODAL_ID';

const CreateWorkOrderFromIssuesBtn = ({
  onFinish,
  title,
  type,
  shouldDisableButton,
  issues,
}) => {
  const [isSaving, setIsSaving] = useState(false);
  const [openVehicleId, setOpenVehicleId] = useState([]);
  const [tabToClose, setTabToClose] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [seed, setSeed] = useState(1);

  const resetModalForm = () => {
    setSeed(Math.random());
  };

  const issuesGroupedByVehicles = _.groupBy(issues, 'car.id');

  const handleOpenModal = () => {
    if (!_.isEmpty(issues)) {
      setTabToClose(null);
      resetModalForm();
      setIsModalOpen(true);
      AppStore.openModals.set(CREATE_WORK_ORDER_MODAL_ID, true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const createWorkOrder = async (payload) => {
    const response = await WorkOrderStore.createWorkOrderOnCustomEndpoint({
      workOrder: {
        id_car: +payload.woSelectVehicle,
        id_shop: ShopStore.currentShop.id,
        status: payload.woStatus,
        type: payload.woRepairType,
        priority: payload.woRepairPriority,
        invoice_number: payload.woInvoiceNumber,
        assigned_to: +payload.woAssignedTo,
        created_by: +payload.woCreatedBy,
        migrate_source: 'PitStop',
        location_code: payload.woLocation,
      },
    });
    return response;
  };

  const saveWorkOrderLines = async (workOrder, lineItems = []) => {
    const formattedWorkOrderLines =
      WorkOrderStore.formatWorkOrderLines(lineItems);
    const payloadToSave = {
      workOrderLines: formattedWorkOrderLines,
    };
    const response = await WorkOrderStore.saveWorkOrderLinesOnCustomEndpoint(
      +workOrder.id,
      payloadToSave
    );
    return response;
  };

  const createWorkOrderForEachVehicle = async (payload, vehicleId) => {
    // const issuesGroupedByVehicles = _.groupBy(issues, 'car.id');
    // const simpleArrayWithVehicleIssues = [];
    // for (const vehicleId in issuesGroupedByVehicles) {
    //   simpleArrayWithVehicleIssues.push({
    //     vehicleId,
    //     issues: issuesGroupedByVehicles[vehicleId],
    //   });
    // }

    const vehicleIssues = issuesGroupedByVehicles[vehicleId] || [];

    // const workOrders = [];
    // for (const vehicleIssues of simpleArrayWithVehicleIssues) {
    //   const issues = vehicleIssues.issues;
    const workOrder = await createWorkOrder({
      woSelectVehicle: vehicleId,
      woStatus: payload.woStatus,
      woRepairType: payload.woRepairType,
      woRepairPriority: payload.woRepairPriority,
      woInvoiceNumber: `${payload.woInvoiceNumber}`,
      woAssignedTo: payload.woAssignedTo,
      woCreatedBy: payload.woCreatedBy,
      woLocation: payload.woLocation,
    });
    await saveWorkOrderLines(workOrder, [
      {
        title: 'Issues',
        description: payload.woDescription,
        laborTotal: 0,
        partsTotal: 0,
        parts: [],
        labours: [],
        services: vehicleIssues.map((issue) => ({
          id_vehicle_service: issue.id,
          key: issue.id,
          name: issue.name,
        })),
      },
    ]);
    // workOrders.push(workOrder);
    // }

    return workOrder;
  };

  const onSaveWorkOrder = async (payload, vehicleId) => {
    // console.log("saving", vehicleId, payload);
    setIsSaving(true);
    try {
      const workOrderCreated = await createWorkOrderForEachVehicle(
        payload,
        vehicleId
      );

      PitstopTableCacheStore.deleteKey(
        `${ShopStore.currentShop.id}-work-order-list`
      );

      // const firstWorkOrder = _.first(workOrdersCreated);

      AppStore.openModals.set(
        `${CREATE_WORK_ORDER_MODAL_ID}_${vehicleId}`,
        false
      );
      setIsSaving(false);
      // resetModalForm();
      WorkOrderStore.clearShopWorkOrdersCache();

      notification.success({
        message: 'Work Order Created',
        description: 'The work order was created successfully.',
      });

      setTabToClose(vehicleId);

      if (openVehicleId.length === 1) onFinish(workOrderCreated);
    } catch (error) {
      console.error('Error creating work order:', error);
      setIsSaving(false);
      let friendlyMsg =
        'Sorry, there was an issue trying to save the Work Order. Please try again later';
      if (
        error &&
        error.message &&
        error.message.isJSON() &&
        JSON.parse(error.message)
      ) {
        const errorObj = JSON.parse(error.message);
        friendlyMsg = _.isArray(errorObj.message)
          ? errorObj.message[0]
          : errorObj.message;
      }
      notification.error({
        message: 'Oops!',
        key: 'orderSaveError',
        description: <Container>{friendlyMsg}</Container>,
      });
    }
  };

  return (
    <>
      <Button
        // onClick={async () => {
        //   if (!_.isEmpty(issues)) {
        //     AppStore.openModals.set(CREATE_WORK_ORDER_MODAL_ID, true);
        //   }
        // }}
        onClick={handleOpenModal}
        type={type}
        disabled={shouldDisableButton}
      >
        <BookOutlined />
        {title}
      </Button>

      {isModalOpen && (
        <CreateWorkOrderModal
          key={seed}
          modalId={CREATE_WORK_ORDER_MODAL_ID}
          visible={isModalOpen}
          issuesGroupedByVehicles={issuesGroupedByVehicles}
          title={'Create Work Order(s)'}
          isLoading={false}
          loading={isSaving}
          onSave={onSaveWorkOrder}
          type="issues"
          onCancel={handleCloseModal}
          tabToClose={tabToClose}
        />
      )}
    </>
  );
};

CreateWorkOrderFromIssuesBtn.propTypes = {
  onFinish: PropTypes.func,
  title: PropTypes.string,
  type: PropTypes.string,
  issues: PropTypes.array.isRequired,
  shouldDisableButton: PropTypes.bool,
  isLoading: PropTypes.bool,
};

CreateWorkOrderFromIssuesBtn.defaultProps = {
  shouldDisableButton: false,
  type: 'primary',
  title: 'Create Work Order',
  onFinish: () => {},
  isLoading: false,
};

export default CreateWorkOrderFromIssuesBtn;
